import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useTaskCache } from '../task'
import { useEventCache } from './cache'
import {
  type CalendarEventConfirmInput,
  type CalendarEventConfirmSuccess,
  type CalendarEventData,
  Logger,
  toResponseError,
} from '@terros/common'

const logger = new Logger('calendar-event-confirm')

export function useConfirmCalendarEvent(): AddHookResponse<CalendarEventConfirmInput, CalendarEventData> {
  const eventCache = useEventCache()
  const taskCache = useTaskCache()
  const mutation = useTantalimMutation<CalendarEventConfirmInput, CalendarEventConfirmSuccess>({
    url: '/calendar/event/confirm',
  })

  async function add(input: CalendarEventConfirmInput): Promise<CalendarEventData> {
    try {
      const output = await mutation.mutateAsync(input)
      eventCache.replaceItem(output.event)
      taskCache.clearList()
      logger.verbose('confirm succeeded', output)
      return output.event
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
